import { createApp } from 'vue';
import { createI18n } from 'vue-i18n'
import App from './App.vue';
import store from './store';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import ro from './locales/ro.json';
import ImageBlock from './components/blocks/ImageBlock.vue'
import HtmlBlock from './components/blocks/HtmlBlock.vue'
import ButtonBlock from './components/blocks/ButtonBlock.vue'
import TextBlock from './components/blocks/TextBlock.vue'
import HeadingBlock from './components/blocks/HeadingBlock.vue'
import DividerBlock from './components/blocks/DividerBlock.vue'
import SpacerBlock from './components/blocks/SpacerBlock.vue'
import ColumnsContainerBlock from './components/blocks/ColumnsContainerBlock.vue'
import ContainerBlock from './components/blocks/ContainerBlock.vue'
import RulesetBlock from './components/blocks/RulesetBlock.vue';
import QrBlock from './components/blocks/QrBlock.vue';
import DynamicBlock from './components/blocks/DynamicBlock.vue';
import DynContainerBlock from './components/blocks/DynContainerBlock.vue';
import Tooltip from "@/components/Reusables/Feedback/Tooltip.vue"
import './styles/themes.css'; // Globale CSS-Datei
import 'material-icons/iconfont/material-icons.css';
import 'material-symbols';
import clickOutside from './utils/directives/clickOutside';




const i18n = createI18n({
  locale: store.state.locale || 'en', // Verwende die Sprache aus dem Store oder Standard 'en'
  fallbackLocale: 'en', // Fallback-Sprache, falls eine Übersetzung fehlt
  messages: {
    en,
    de,
    es,
    ro,
    fr
  }
});
 
const app = createApp(App);

app.component('ImageBlock', ImageBlock)
app.component('HtmlBlock', HtmlBlock)
app.component('ButtonBlock', ButtonBlock)
app.component('TextBlock', TextBlock)
app.component('HeadingBlock', HeadingBlock)
app.component('DividerBlock', DividerBlock)
app.component('SpacerBlock', SpacerBlock)
app.component('ColumnsContainerBlock', ColumnsContainerBlock)
app.component('ContainerBlock', ContainerBlock)
app.component('RulesetBlock', RulesetBlock)
app.component('QrBlock', QrBlock)
app.component('DynamicBlock', DynamicBlock)
app.component('Tooltip', Tooltip)
app.component('DynContainerBlock', DynContainerBlock)

app.use(store)
app.use(i18n)

app.directive('click-outside', clickOutside);


store.dispatch('loadEmailData').then(() =>{ store.dispatch('loadEnvVars')
    app.mount('#app');
  });




